<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="选择月份" prop="time" style="width: 80%">
                <el-date-picker
                  v-model="searchForm.time"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad"
                type="primary"
                icon="el-icon-search"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                icon="el-icon-refresh"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column
          :prop="item.dataIndex"
          :label="item.title"
          :width="item.width"
          :align="item.align"
          v-for="(item, index) in tabList"
          :key="index"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        time: "",
      },
      tableData: [],
      tabList: [],
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    onLoad() {
      let data = {
        ...this.searchForm,
      };
      this.$Apis.billMonthReportForm(data).then((res) => {
        if (res.code == 200) {
          var arr = [],
            arr1 = [];
          res.data[0].dateList.forEach((re, ind) => {
            arr.push(re);
            arr[ind].title = re.date;
            arr[ind].key = ind + 1;
            arr[ind].dataIndex = "value-" + ind;
            arr[ind].width = "130px";
            arr[ind].align = "center";
          });
          arr.unshift({
            title: "缴费类型",
            dataIndex: "name",
            scopedSlots: { customRender: "name" },
            width: "130px",
            align: "center",
          });

          res.data.forEach((re, inds) => {
            var obj = {
              name: re.name,
              id: re.id,
            };
            re.dateList.forEach((r, ind) => {
              var value = "value-" + ind;
              obj[value] = r.typePrice;
            });
            arr1.push(obj);
          });
          this.$nextTick(() => {
            this.tabList = arr;
            this.tableData = arr1;
          });
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px 25px;
  border-radius: 5px;
  background: #fff;
}
</style>